import {
  GameType,
  PeriodType,
  PrizeType,
  TicketType,
  UserMissionStatus,
  UserPrizeStatus,
} from '@/types/bff/gql-schema';

export interface Prize {
  amount: number;
  displayName: string;
  id: string;
  name: string;
  type: PrizeType;
  thumbnailUrl: string;
  winningImageUrl: string;
  formattedGuidance: string;
}

export interface UserPrize {
  drawnAt: number;
  id: string;
  quantity: number;
  receivedAt?: number | null;
  status: UserPrizeStatus;
  userId: string;
  prize: Prize;
}

export interface ActivePrizeStrategies {
  gameType: GameType;
  id: string;
  quantity: number;
  prize: Prize;
}

export interface MissionVo {
  id: string;
  endAt: number;
  name: string;
  periodType: PeriodType;
  quantity: number;
  startAt: number;
  ticketType: TicketType;
  type: UserMissionTypeVo;
  targetLink?: string | null;
  maxCount: number;
  visible: boolean;
}

export interface Ticket {
  id: string;
  quantity: number;
  ticketType: TicketType;
  userId: string;
}

export interface MissionRecordVo {
  completedAt?: number | null;
  status: UserMissionStatus;
  mission: MissionVo;
  completionCount: number;
  isCompleted: boolean;
  leftCount: number;
  hasMultipleChances: boolean;
  displayText: string;
}

export interface UserMissionQueries {
  viewType?: string;
}

export interface UserMissionVo {
  userId: string;
  missionRecords: Array<MissionRecordVo>;
  userTickets: Array<Ticket>;
}

export enum UserMissionTypeVo {
  AdWatch = 'AD_WATCH',
  AttendanceCheck = 'ATTENDANCE_CHECK',
  MagazineRead = 'MAGAZINE_READ',
  QnaRead = 'QNA_READ',
  Unknown = 'UNKNOWN',
}
